var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tenant-sidebar-menu',{attrs:{"collapsed":_vm.isCollapse,"active-index":_vm.defaultActiveIndex},on:{"toggle":_vm.toggleSwitch}},[_c('tenant-sidebar-tree',{attrs:{"nodes":_vm.sidebarNodes},on:{"select":_vm.navigateSidebarNode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }